var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"mobile-sub-header",attrs:{"type":"dark"}},[_c('search-nav-item')],1)}
var staticRenderFns = []
export { render, staticRenderFns }